'use strict';

import 'angular';

export default function($timeout, toastr) {
	'ngInject';
    const vm = {
        lastUpdated: null,
    };
    const options = JSON.parse(localStorage.getItem('_userOptions')) || {};

    function _setOption(key, value) {
        const oldValue = JSON.stringify(options);
        options[key] = value;
        localStorage.setItem('_userOptions', JSON.stringify(options));
        window.dispatchEvent(new StorageEvent(
            'storage',
            {
                key: '_userOptions',
                oldValue,
                newValue: JSON.stringify(options),
            },
        ));
        vm.lastUpdated = new Date();
    }

    function _getOption(key) {
        return options[key];
    }

    vm.setStaffView = function(value) {
        _setOption('staffView', !!value);
        if (value) {
            toastr.success('Staff view enabled');
        } else {
            toastr.success('Staff view disabled');
        }
    }

    window.addEventListener('storage', (event) => {
        $timeout(() => {
            if (event.key !== '_userOptions') { return; }
            if (event.newValue === JSON.stringify(localStorage.getItem('_userOptions'))) {
                return;
            }
            const value = JSON.parse(event.newValue);
            Object.entries(value).forEach(([key, value]) => {
                options[key] = value;
            });
            vm.lastUpdated = new Date();
        }, 0);
    });

    vm.getStaffView = function() {
        return !!_getOption('staffView');
    }

    return vm;
}
